import React, { useEffect } from "react";
import Select from "react-select";
import { calculateRentalDuration, calculateRentPrice, comma, formatNumberWithCommas } from "@/utils";
import { chargeRateOptions } from "@/constants/selectOptions";
import { sumRentalDurations, calculateRentPriceWithGroupBasePrice } from "@/utils/calculator";

export const BillingInfo = ({
    formData,
    handleChange,
    setFormData,
    contract,
    onContractChange,
    selectedContractIndex,
    setSelectedContractIndex,
}) => {
    const { contractInsurance } = formData;
    const { allocation, billingInfo, rentPriceItem } = contract;

    // 상세조회 시 rentPriceItem이 있고 billingInfo.rentPrice가 없으면 자동 세팅
    useEffect(() => {
        if (rentPriceItem && (!billingInfo || !billingInfo.rentPrice)) {
            setFormData((prev) => {
                const updatedContracts = [...prev.contracts];
                updatedContracts[selectedContractIndex] = {
                    ...updatedContracts[selectedContractIndex],
                    billingInfo: {
                        ...(updatedContracts[selectedContractIndex].billingInfo || {}),
                        rentPrice: rentPriceItem,
                    },
                };
                return { ...prev, contracts: updatedContracts };
            });
        }
    }, [rentPriceItem, billingInfo, setFormData, selectedContractIndex]);

    useEffect(() => {
        console.log(billingInfo);
    }, [billingInfo]);

    useEffect(() => {
        if (
            billingInfo &&
            billingInfo?.rentPrice &&
            billingInfo?.rentPrice.rentPriceItemDetails &&
            allocation?.releasedAt &&
            allocation?.returnedAt &&
            contractInsurance?.chargeRate
        ) {
            try {
                // contractGroup 전체 대여기간 합산
                const { days: groupDays, hours: groupHours } = sumRentalDurations(formData.contracts);

                // groupDays, groupHours로 기준요금 찾기
                let groupBasePrice = 0;
                let currentRateRow = null;
                if (billingInfo?.rentPrice?.rentPriceItemDetails) {
                    currentRateRow =
                        groupDays >= 7
                            ? billingInfo.rentPrice.rentPriceItemDetails.find((item) => item.title === "7일이상")
                            : billingInfo.rentPrice.rentPriceItemDetails.find(
                                  (item) => item.startHour <= groupDays * 24 + groupHours && item.endHour > groupDays * 24 + groupHours
                              );
                    groupBasePrice = currentRateRow?.price || 0;
                }

                // 개별 계약의 대여기간
                const { days, hours, totalMinutes } = calculateRentalDuration(allocation?.releasedAt, allocation?.returnedAt);

                // 요금 계산
                const chargeRate = contractInsurance.chargeRate;
                const platformCommissionRate = formData.platformCommissionRate || 8.0;

                let baseDivideHours = 24;
                if(totalMinutes < (60 * 10)) {
                    baseDivideHours = 10;
                } else if(totalMinutes < (60 * 12)) {
                    baseDivideHours = 12;
                }

                const result = calculateRentPriceWithGroupBasePrice(groupBasePrice, days, hours, chargeRate, platformCommissionRate, baseDivideHours);

                // 수식 문자열
                const formulaStr = `((${comma(groupBasePrice)} * ${days}) + (${comma(groupBasePrice)} * (${hours} / ${baseDivideHours}))) * ${
                    chargeRate / 100
                } = ${comma(result.chargeFee)}`;

                setFormData((prev) => {
                    const updatedContracts = [...prev.contracts];
                    updatedContracts[selectedContractIndex] = {
                        ...updatedContracts[selectedContractIndex],
                        billingInfo: {
                            ...updatedContracts[selectedContractIndex].billingInfo,
                            totalRentalPeriod: `${days}일 ${hours}시간`,
                            days,
                            hours,
                            rentFee: result.rentFee,
                            insuranceChargeFee: result.insuranceChargeFee,
                            platformCommissionFee: result.platformCommissionFee,
                            exceptCommissionFee: result.exceptCommissionFee,
                            exceptAddTaxFee: result.exceptAddTaxFee,
                            orderCommissionFee: result.orderCommissionFee,
                            obtainEarningFee: result.obtainEarningFee,
                            chargeFee: comma(result.chargeFee),
                            formula: formulaStr,
                        },
                    };
                    return { ...prev, contracts: updatedContracts };
                });
            } catch (error) {
                console.error("청구수식 계산 오류:", error);
            }
        }
    }, [
        contractInsurance?.chargeMethod,
        contractInsurance?.chargeRate,
        allocation?.releasedAt,
        allocation?.returnedAt,
        formData.billingSettingPopupStatus,
        billingInfo?.rentPrice,
    ]);

    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>대여기간</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="totalRentalPeriod" placeholder="" value={billingInfo?.totalRentalPeriod || ""} disabled />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>청구율</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={chargeRateOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable
                            placeholder="청구율"
                            value={chargeRateOptions?.find((opt) => opt.value === contractInsurance?.chargeRate)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    contractInsurance: {
                                        ...prev.contractInsurance,
                                        chargeRate: option.value,
                                    },
                                }));
                            }}
                            isDisabled
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>청구기준</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="modelTitle" placeholder="" value={billingInfo?.rentPrice?.modelTitle || ""} disabled />
                    </div>
                    <div className="form-element_button">
                        <button
                            type="button"
                            className="btn-form_element btn-outline"
                            onClick={() => {
                                if (!formData.contractInsurance?.chargeMethod) {
                                    setFormData((prevState) => ({
                                        ...prevState,
                                        toastMsg: "청구 방법을 먼저 선택해주세요.",
                                    }));
                                    return;
                                }
                                if (!allocation?.releasedAt || !allocation?.returnedAt) {
                                    setFormData((prevState) => ({
                                        ...prevState,
                                        toastMsg: "계약의 배차일시, 반납일시가 선택되어있어야 합니다.",
                                    }));
                                    return;
                                }
                                setFormData((prevState) => ({
                                    ...prevState,
                                    billingSettingPopupStatus: true,
                                }));
                                setSelectedContractIndex(selectedContractIndex);
                            }}
                        >
                            청구기준설정
                        </button>
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>청구 요금</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="chargeFee"
                            placeholder=""
                            value={billingInfo?.chargeFee || ""}
                            onInput={formatNumberWithCommas}
                            disabled
                        />
                        <span className="input-esset">원</span>
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>청구 수식</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="formula" placeholder="" value={billingInfo?.formula || ""} disabled />
                    </div>
                </div>
            </div>
        </>
    );
};
